import React from 'react';
import PropTypes from 'prop-types';
import { Form, ErrorMessage } from 'formik';
import ReactHtmlParser from 'react-html-parser';
import IMAGES from 'modules/assets/web';
import PhoneNumberInput from 'modules/components/web/phone-number-input';
import StepControlButton from './StepControl';
import {
  SelectField,
  TextField,
  NumberField,
  CheckboxField,
  TextareaField,
  FieldsArray,
  DateField,
} from './CustomFields';

class OnboardingForm extends React.Component {
  renderEmptyElement = () => (
    <div className="form-control empty flex-1 col-md-6 ml-md-2 mr-md-2 mb-md-3 p-0" />
  );

  renderRequiredIcon = () => (
    <span className="d-inline-block ml-2">
      <img alt="required" src={IMAGES.ASTERISK_RED} />
    </span>
  );

  renderGroup = group => {
    const { name, fields } = group;

    return (
      <div key={name} className="form__group col-sm-10 p-md-0">
        <div className="form__fields-wrapper d-flex flex-column">
          {this.renderFields(fields)}
        </div>
      </div>
    );
  };

  renderFields = fields => fields.map(field => this.renderField(field));

  renderField = field => {
    const { type } = field;
    const { formikProps } = this.props;

    switch (type) {
      case 'select':
        return (
          <SelectField
            key={field.name}
            field={field}
            formikProps={formikProps}
            renderRequiredIcon={this.renderRequiredIcon}
          />
        );
      case 'number':
        return (
          <NumberField
            key={field.name}
            field={field}
            formikProps={formikProps}
            renderRequiredIcon={this.renderRequiredIcon}
          />
        );
      case 'text':
        return (
          <TextField
            key={field.name}
            field={field}
            formikProps={formikProps}
            renderRequiredIcon={this.renderRequiredIcon}
          />
        );
      case 'multiselect':
        return (
          <CheckboxField
            key={field.name}
            field={field}
            formikProps={formikProps}
            renderRequiredIcon={this.renderRequiredIcon}
            renderEmptyElement={this.renderEmptyElement}
          />
        );
      case 'textarea':
        return (
          <TextareaField
            key={field.name}
            field={field}
            formikProps={formikProps}
            renderRequiredIcon={this.renderRequiredIcon}
            renderEmptyElement={this.renderEmptyElement}
          />
        );
      case 'fieldsArray':
        return (
          <FieldsArray
            key={field.name}
            field={field}
            renderFields={this.renderFields}
          />
        );
      case 'date':
        return (
          <DateField
            key={field.name}
            field={field}
            formikProps={formikProps}
            renderRequiredIcon={this.renderRequiredIcon}
          />
        );

      case 'phone':
        return (
          <div
            key={field.name}
            className="form__field text d-flex flex-column align-items-center justify-content-center"
          >
            <label htmlFor="name" className="field-label text-center">
              {ReactHtmlParser(field.caption)}
              {this.renderRequiredIcon()}
            </label>
            <PhoneNumberInput
              key={field.name}
              number={formikProps.values.phoneNumber}
              fieldName={field.name}
              // value={formikProps.values.phoneNumber}
              setFieldValue={formikProps.setFieldValue}
              renderRequiredIcon={this.renderRequiredIcon}
              setFieldTouched={formikProps.setFieldTouched}
              disableAutosave={false}
            />
            <span className="small font-italic">
              Must include country code; US is +1
            </span>
            <ErrorMessage
              render={msg => <div className="validateError">{msg}</div>}
              name={field.name}
            />
          </div>
        );
      default:
        break;
    }
    return null;
  };

  render() {
    // console.devLog.info('Onboarding values:', this.props.formikProps);
    const { groups, currentGroup } = this.props;

    return (
      <Form className="form d-flex flex-column align-items-center">
        <div className="sub col-sm-10 mx-auto mb-2 questionnaire-section-intro">
          <div className="intro-box">
            {ReactHtmlParser(groups[currentGroup - 1].intro)}
          </div>
        </div>
        {groups.map(
          (group, index) =>
            index + 1 === currentGroup && this.renderGroup(group),
        )}
        <StepControlButton {...this.props} />
      </Form>
    );
  }
}

OnboardingForm.propTypes = {
  groups: PropTypes.array.isRequired,
  formikProps: PropTypes.object.isRequired,
  currentGroup: PropTypes.number.isRequired,
  onNextHandler: PropTypes.func.isRequired,
  setSubmitPossible: PropTypes.func.isRequired,
  isExistingEntry: PropTypes.bool.isRequired,
  myTrainer: PropTypes.object.isRequired,
};

export default OnboardingForm;
